import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from './radiobutton.component';
import { RadioButtonModule } from './radiobutton.module';
/**
 * NgModule definition for the RadioButton component with providers.
 */
export class RadioButtonAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, RadioButtonModule],
    exports: [
        RadioButtonModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RadioButtonAllModule_tsickle_Closure_declarations() {
/** @type {?} */
RadioButtonAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioButtonAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
